import React from 'react';
import { motion } from 'framer-motion';
const segments = [{
  id: 'S-01',
  title: 'STARTUP / SMALL TEAM',
  desc: 'Focus on fast setup and unblocking PRs without heavy process.',
  scenarios: [{
    goal: 'FASTEST DORA SETUP',
    tools: 'WAYDEV, SLEUTH'
  }, {
    goal: 'SPEED UP PR REVIEWS',
    tools: 'WAYDEV, LINEARB'
  }]
}, {
  id: 'S-02',
  title: 'SCALEUP / MID-MARKET',
  desc: 'Balancing delivery speed with developer happiness and team health.',
  scenarios: [{
    goal: 'END-TO-END VISIBILITY',
    tools: 'WAYDEV'
  }, {
    goal: 'IMPROVE DEVEX & CULTURE',
    tools: 'DX, SWARMIA'
  }, {
    goal: 'AUTOMATE WORKFLOWS',
    tools: 'LINEARB'
  }]
}, {
  id: 'S-03',
  title: 'ENTERPRISE',
  desc: 'Focus on business alignment, R&D capitalization, and governance.',
  scenarios: [{
    goal: 'R&D CAP & EXEC DASHBOARDS',
    tools: 'WAYDEV, JELLYFISH'
  }, {
    goal: 'DEEP CI/CD INTEGRATION',
    tools: 'HARNESS SEI'
  }, {
    goal: 'ENTERPRISE DEVEX AT SCALE',
    tools: 'DX'
  }]
}];
export function ChooseGuide() {
  return <section id="guide" className="py-24 bg-blueprint relative hairline-t" data-id="element-53">
      <div className="absolute inset-0 bg-scanlines pointer-events-none opacity-30" data-id="element-54" />

      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8 relative z-10" data-id="element-55">
        <div className="mb-16 font-mono" data-id="element-56">
          <div className="text-lime text-xs tracking-widest mb-4" data-id="element-57">
            §04 / ROUTING
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink uppercase tracking-tight mb-6" data-id="element-58">
            Decision Logic
          </h2>
          <p className="text-ink/60 text-sm max-w-2xl leading-relaxed hairline-l pl-6 border-ink/20" data-id="element-59">
            Routing recommendations based on organizational stage and primary
            telemetry goals.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 hairline-t hairline-l" data-id="element-60">
          {segments.map((segment, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          ease: 'easeOut'
        }} className="hairline-r hairline-b p-8 bg-base relative" data-id="element-61">
              <div className="font-mono text-[10px] text-ink/30 mb-6 tracking-widest" data-id="element-62">
                ID: {segment.id}
              </div>

              <h3 className="font-display text-2xl font-bold text-ink mb-2 uppercase" data-id="element-63">
                {segment.title}
              </h3>
              <p className="font-mono text-xs text-ink/50 mb-8 leading-relaxed" data-id="element-64">
                {segment.desc}
              </p>

              <div className="space-y-4 font-mono text-xs" data-id="element-65">
                {segment.scenarios.map((scenario, idx) => <div key={idx} className="hairline-all p-4 bg-ink/5" data-id="element-66">
                    <div className="text-ink/40 tracking-widest mb-2" data-id="element-67">
                      IF GOAL ==
                    </div>
                    <div className="text-ink font-bold mb-4" data-id="element-68">
                      {scenario.goal}
                    </div>
                    <div className="flex items-center gap-2" data-id="element-69">
                      <span className="text-ink/40" data-id="element-70">THEN ROUTE_TO:</span>
                      <span className="text-lime" data-id="element-71">{scenario.tools}</span>
                    </div>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}